import React, { useState, useCallback, useEffect } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';

import { Modal, ModalElement } from '../../common';
import ZipCodeForm from '../ZipCodeForm';
import ZipCodeHelper from '../ZipCodeHelper';

import { useAppWidthClass } from '../../../utils/hooks';

const useStyles = makeStyles(theme => ({
  backdrop: {
    background: theme.palette.background.dark
  },
  modalPaper: {
    maxWidth: 352,
    width: '100%',
    borderRadius: 24
  }
}));

const ZipCodeModal = ({
  isOpen,
  onClose,
  onSubmit,
  attempt,
  maxAttempts,
  isLoading,
  prevalidate
}) => {
  const classes = useStyles();
  const { isMobileWidth } = useAppWidthClass();

  const [helperOpened, setHelperOpened] = useState(false);

  const onZipCodeHelpClick = useCallback(() => {
    setHelperOpened(true);
  }, []);
  const onZipCodeHelperClose = useCallback(() => {
    setHelperOpened(false);
  }, []);

  useEffect(() => {
    if (!maxAttempts) {
      prevalidate && prevalidate();
    }
  }, [maxAttempts]);

  return (
    <>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        backdropClassName={classes.backdrop}
        paperClassName={classNames(
          classes.modalPaper,
          isMobileWidth && classes.modalPaperMobile
        )}
      >
        <ZipCodeForm
          onSubmit={onSubmit}
          onLoginHelpClick={onZipCodeHelpClick}
          attempt={attempt}
          maxAttempts={maxAttempts}
          isLoading={isLoading}
        />
      </Modal>
      <Modal withFullSizePaper isOpen={helperOpened}>
        <ModalElement className={classes.modalPaper}>
          <ZipCodeHelper onButtonClick={onZipCodeHelperClose} />
        </ModalElement>
      </Modal>
    </>
  );
};

export default ZipCodeModal;
